export enum D3GraphSetting {
  svgHeight = 750,

  nodeWidth = 200,
  nodeHeight = 40,
  nodeSpacing = 50,
  nodeBorderRadius = 10,

  mainCardFillColor = '#110133',
  mainCardTextColor = '#FFFFFF',

  textColor = '#110133',
  textCharacterLimit = 18, // Looks fine until it gets to three digits

  strokeColor = '#110133',
  fillColor = '#FFFFFF',

  elementPadding = 10,
  iconSize = 15,
  ContainerID = 'd3-container',
}
